import React, { useState } from "react";

import BrandingPricing from "./BrandingPricing";
import LeadsPricing from "./LeadsPricing";
import OffersPricing from "./OffersPricing";
import DigitalPricing from "./DigitalPricing";

import "./PromotionPricingSection.css";

const CampaignsDetails = () => {

    const [activeTab, setActiveTab] = useState("branding");

    const tabs = [
        {
            id: "branding",
            label: "Branding"
        },
        {
            id: "leads",
            label: "Leads"
        },
        {
            id: "offers",
            label: "Offers"
        },
        {
            id: "digital",
            label: "Digital Screens"
        }
    ];

    const renderComponent = () => {

        switch (activeTab) {

            case "branding":
                return <BrandingPricing />;

            case "leads":
                return <LeadsPricing />;

            case "offers":
                return <OffersPricing />;

            case "digital":
                return <DigitalPricing />;

            default:
                return <BrandingPricing />;
        }

    };

    return (
        <section className="maamaasPricingWrapper">

            <div className="maamaasPricingContainer">

                {/* Tabs */}

                <div
                    style={{
                        display: "flex",
                        justifyContent: "left",
                        gap: "15px",
                        margin: "20px 0",
                        flexWrap: "wrap"
                    }}
                >
                    {tabs.map((tab) => (

                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            style={{
                                padding: "8px 18px",
                                borderRadius: "20px",
                                border:
                                    activeTab === tab.id
                                        ? "none"
                                        : "1px solid #d1d5db",

                                background:
                                    activeTab === tab.id
                                        ? "#4f46e5"
                                        : "#fff",

                                color:
                                    activeTab === tab.id
                                        ? "#fff"
                                        : "#374151",

                                cursor: "pointer",

                                fontWeight: 600,

                                transition: "all .3s",
                               
                            }}
                        >
                            {tab.label}
                        </button>

                    ))}
                </div>

                {renderComponent()}

            </div>

        </section>
    );

};

export default CampaignsDetails;